import React from 'react'

import { useShallow } from 'zustand/react/shallow'

import FileUpload from '../../components/FileUpload'
import Footer from '../../components/Footer'
import { Header } from '../../components/Header'
import ReviewSuggestionsToggle from '../../components/ReviewSuggestionsToggle'
import Suggestions from '../../components/Suggestions'
import { Toaster } from '@harvey-frontend/components/ui/toaster'

import useSelectedText from '../../hooks/useSelectedText'
import { useAccessTokenContext } from '../../providers/AccessTokenProvider'
import useAppStore from '../../stores/store'
import Instruction from './Instruction'
import { SelectedTextDisplay } from './SelectedTextDisplay'

const InstructionEditScreen = () => {
  const { userInfo } = useAccessTokenContext()
  const setHighlightedText = useAppStore(
    useShallow((s) => s.setHighlightedText)
  )
  useSelectedText(setHighlightedText)

  return (
    <>
      <Toaster
        position="top-left"
        expand
        closeButton
        visibleToasts={5}
        className="pointer-events-auto list-none"
      />
      <div className="flex h-screen w-full flex-col">
        {userInfo?.isPlaybookReviewUser && <Header title="Edit document" />}
        <div className="flex flex-1 flex-col gap-2 px-4 pt-4">
          <div className="flex size-full flex-col gap-2.5">
            <div className="leading-none">
              <span className="bg-highlight text-xs">Highlight text</span>
              <span className="text-xs">
                {' '}
                to revise the selection, or place your cursor anywhere to draft
                new text.
              </span>
            </div>
            <SelectedTextDisplay />
            <Instruction />
            <ReviewSuggestionsToggle />
            <Suggestions />
            <FileUpload />
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default InstructionEditScreen
